import { render, staticRenderFns } from "./SentimentMarketTopN.vue?vue&type=template&id=a4085cfe&scoped=true"
import script from "./SentimentMarketTopN.vue?vue&type=script&lang=js"
export * from "./SentimentMarketTopN.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketTopN.vue?vue&type=style&index=0&id=a4085cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4085cfe",
  null
  
)

export default component.exports